import { Component, HostListener, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'src/app/modules/core/services/message.service';
import { SupportChatService } from '../../services/support-chat.service';
import { TndPagesVisibilityService } from '../../services/tnd-pages-visibility.service';
import { LoginPopupComponent } from '../login-popup/login-popup.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [DialogService],
})
export class FooterComponent {
  /**
   * Hide the language toolbar this footer renders. On desktop that toolbar
   * is the fixed FR/EN tab at the right edge; the provider lobby turns it
   * off because the vendor frame owns that edge (its betslip and history
   * live there). Default false: every other page keeps it.
   */
  @Input() hideLanguageToolbar = false;

  currentYear = new Date().getFullYear();
  // The payments guide link only shows for logged-in TND accounts.
  canSeeTndPayments$ = this.tndVisibility.canSeeTndPayments$;
  private loginRef: DynamicDialogRef;

  constructor(
    private supportChat: SupportChatService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private tndVisibility: TndPagesVisibilityService,
  ) { }

  // Footer "Contact" opens the support live chat (login popup for anonymous
  // visitors) — same flow as the sticky toolbar.
  async openSupportChat(): Promise<void> {
    try {
      const result = await this.supportChat.open();
      if (result === 'login-required') {
        this.loginRef = this.dialogService.open(LoginPopupComponent, {
          showHeader: true,
          dismissableMask: true,
          closable: true,
          styleClass: 'login-modal',
          contentStyle: { 'border-radius': '4px', padding: '0', 'z-index': '999' },
        });
      }
    } catch (e) {
      this.messageService.showPopup(
        this.translateService.instant('SUPPORT.UNAVAILABLE'),
        'alert',
        'fail',
        'p0Popup'
      );
    }
  }

  topFunction(): any {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  @HostListener('window:scroll', []) onWindowScroll(): any {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
  scrollFunction(): any {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      document.getElementById('myBtn').style.display = 'block';
    } else {
      document.getElementById('myBtn').style.display = 'none';
    }
  }
}
